//★★★　アプリケーションのエントリポイント　★★★  ビルド後のindex.htmlの最初で呼び出されます。
console.log(process.env.NODE_ENV);
console.log(process.env.VUE_APP_SUBDOMAIN);

//冒頭でAuthを初期化する
import {auth} from './agiles/common/auth';

import Vue from 'vue';

//モジュール登録
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);

//iOS・Macなどで不正な文字が入力される不具合の修正
var bFormInput = Vue.component('bFormInput');
(bFormInput as any).extendOptions.methods.setValue = function(value:any){
    this.$emit('input',value);
    if (this.$el.value != value) this.$el.value = value;
    };

import api, {Api} from './agiles/common/api';
Vue.use(api);
import Words,{words} from './agiles/common/words';
Vue.use(Words);

//スタイル登録
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'material-icons/iconfont/material-icons.css';
import 'material-symbols/outlined.css';
import './agiles/components/style.css';
import './tenant/style.scss';

//実装クラス・コンポーネント登録・初期化登録
import * as Common  from './tenant/common';
import './tenant/components';

//検品アプリのmanifestタグを動的に挿入する
if(location.pathname.startsWith('/barcode')){
  const link = document.createElement('link');
  link.rel = 'manifest';
  link.href = '/manifest-mobile.json';
  document.head.appendChild(link);    

  const metaCapable = document.createElement('meta');
  metaCapable.name = 'apple-mobile-web-app-capable';
  metaCapable.content = 'yes';
  document.head.appendChild(metaCapable);

  const linkIcon = document.createElement('link');
  linkIcon.rel = 'apple-touch-icon';
  linkIcon.href = '/mobile.png';
  document.head.appendChild(linkIcon);

}

auth.initialize().then(()=>{
    //アプリケーションのロード
    if (auth.isLoggedIn()==false){
    //publicエリア(サイトモード共通)
        import('./public/initialize');
    } else if (Api.siteMode == Common.siteModes.tenant) {
        import('./tenant/initialize');
    } else if (Api.siteMode == Common.siteModes.admin){
        import('./tenantCatalog/initialize');
    } else if (Api.siteMode == Common.siteModes.signup){
        import('./signup/initialize');
    }
});
